module.exports = __webpack_public_path__ + "img/syukyaku-landing-back001.ea295262.jpg";